import Page from './index';

export default {
settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
	},
	// auth: authRoles.user,
	routes: [
		{
			path: '/service-tickets',
			exact: true,
			component: Page.Layout
		},
		{
			path: '/service-tickets/:id',
			exact: true,
			component: Page.Details
		},
		{
			path: '/alert-list',
			exact: true,
			component: Page.AlertLayout
		},
	]
};